import React from 'react';
import SiteNav from '../../components/site/SiteNav';
import SiteFooter from '../../components/site/SiteFooter';
import { Mail, Phone, MapPin, MessageCircle, Clock, Send } from 'lucide-react';
import { useAlert } from '../../context/AlertContext';

const Contact = () => {
    const { showAlert } = useAlert();
    return (
        <div style={{ background: 'var(--bg-main)', minHeight: '100vh' }}>
            <SiteNav />

            <section style={{
                padding: '16rem 10% 6rem',
                background: 'linear-gradient(180deg, rgba(var(--primary-rgb), 0.08) 0%, transparent 100%)',
                textAlign: 'center',
                position: 'relative'
            }}>
                <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 24px',
                    background: 'rgba(var(--primary-rgb), 0.1)',
                    color: 'var(--primary)',
                    borderRadius: '99px',
                    fontSize: '0.875rem',
                    fontWeight: 800,
                    marginBottom: '2.5rem',
                    border: '1px solid rgba(var(--primary-rgb), 0.2)',
                    textTransform: 'uppercase',
                    letterSpacing: '2px'
                }}>
                    <MessageCircle size={16} /> <span>İletişim</span>
                </div>
                <h1 style={{ fontSize: 'clamp(3rem, 7vw, 5.5rem)', fontWeight: 900, marginBottom: '2rem', letterSpacing: '-0.04em', lineHeight: 1 }}>
                    Bize <span className="text-gradient">Ulaşın</span>
                </h1>
                <p style={{ fontSize: '1.25rem', color: 'var(--text-muted)', maxWidth: '800px', margin: '0 auto', lineHeight: 1.6 }}>
                    Sorularınız, iş birliği talepleriniz veya teknik destek için ekibimiz her zaman burada.
                </p>
            </section>

            <section style={{ padding: '0 10% 10rem', display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '4rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    <div className="card glass" style={{ padding: '2rem' }}>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1.5rem' }}>
                            <div style={{ background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '12px', borderRadius: '12px' }}><Mail size={24} /></div>
                            <div>
                                <h3 style={{ fontWeight: 700 }}>E-posta</h3>
                                <p style={{ color: 'var(--text-muted)' }}>info@ugra.io</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1.5rem' }}>
                            <div style={{ background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '12px', borderRadius: '12px' }}><Phone size={24} /></div>
                            <div>
                                <h3 style={{ fontWeight: 700 }}>Telefon</h3>
                                <p style={{ color: 'var(--text-muted)' }}>+90 (212) 555 0123</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <div style={{ background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '12px', borderRadius: '12px' }}><MapPin size={24} /></div>
                            <div>
                                <h3 style={{ fontWeight: 700 }}>Ofis</h3>
                                <p style={{ color: 'var(--text-muted)' }}>Maltepe, İstanbul / Türkiye</p>
                            </div>
                        </div>
                    </div>

                    <div className="card" style={{ background: 'var(--primary)', color: 'white', padding: '2rem' }}>
                        <h3 style={{ fontWeight: 700, marginBottom: '1rem' }}>Hızlı Destek</h3>
                        <p style={{ opacity: 0.9, marginBottom: '2rem', fontSize: '0.9375rem' }}>
                            Müşteri panelinizdeki "Yardım" butonunu kullanarak anlık destek talebi oluşturabilirsiniz.
                        </p>
                        <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '1rem', fontSize: '0.875rem' }}>
                            <li style={{ display: 'flex', gap: '10px', alignItems: 'center' }}><Clock size={16} /> Hafta içi: 09:00 - 18:00</li>
                            <li style={{ display: 'flex', gap: '10px', alignItems: 'center' }}><MessageCircle size={16} /> Ortalama Yanıt: 2 Saat</li>
                        </ul>
                    </div>
                </div>

                <div className="card glass" style={{ padding: '3rem' }}>
                    <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '2rem' }}>Mesaj Gönderin</h2>
                    <form onSubmit={(e) => { e.preventDefault(); showAlert('Mesajınız alındı, en kısa sürede dönüş yapacağız.', 'success'); }} style={{ display: 'grid', gap: '1.5rem' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '0.875rem' }}>Adınız</label>
                                <input required type="text" placeholder="Ad Soyad" style={{ width: '100%' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '0.875rem' }}>E-posta</label>
                                <input required type="email" placeholder="example@mail.com" style={{ width: '100%' }} />
                            </div>
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '0.875rem' }}>Konu</label>
                            <input required type="text" placeholder="Nasıl yardımcı olabiliriz?" style={{ width: '100%' }} />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600, fontSize: '0.875rem' }}>Mesajınız</label>
                            <textarea required rows={5} placeholder="Detayları buraya yazabilirsiniz..." style={{ width: '100%', padding: '12px', borderRadius: '12px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-main)', resize: 'none' }}></textarea>
                        </div>
                        <button type="submit" className="btn-primary" style={{ padding: '1rem', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                            <Send size={18} /> Gönder
                        </button>
                    </form>
                </div>
            </section>

            <SiteFooter />
            <style>{`
                .text-gradient {
                    background: linear-gradient(135deg, var(--primary) 0%, #d97706 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                @media (max-width: 1024px) {
                    section { padding: 8rem 5% !important; }
                    section:nth-of-type(2) { grid-template-columns: 1fr !important; }
                }
            `}</style>
        </div>
    );
};

export default Contact;
